<template>
    <div>
        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <!-- <div class="container pt-lg-md">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <card type="secondary" shadow
                            header-classes="bg-white pb-5"
                            body-classes="px-lg-5 py-lg-5"
                            class="border-0">
                            <template>
                                <div class="text-muted text-center mb-3">
                                    <small>Sign in with</small>
                                </div>
                                <div class="btn-wrapper text-center">
                                    <base-button type="neutral">
                                        <img slot="icon" src="img/icons/common/github.svg">
                                        Github
                                    </base-button>

                                    <base-button type="neutral">
                                        <img slot="icon" src="img/icons/common/google.svg">
                                        Google
                                    </base-button>
                                </div>
                            </template>
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small>Or sign up with credentials</small>
                                </div>
                                <form role="form">
                                    <base-input alternative
                                                class="mb-3"
                                                placeholder="Name"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                    <base-input alternative
                                                class="mb-3"
                                                placeholder="Email"
                                                addon-left-icon="ni ni-email-83">
                                    </base-input>
                                    <base-input alternative
                                                type="password"
                                                placeholder="Password"
                                                addon-left-icon="ni ni-lock-circle-open">
                                    </base-input>
                                    <div class="text-muted font-italic">
                                        <small>password strength:
                                            <span class="text-success font-weight-700">strong</span>
                                        </small>
                                    </div>
                                    <base-checkbox>
                                        <span>I agree with the
                                            <a href="#">Privacy Policy</a>
                                        </span>
                                    </base-checkbox>
                                    <div class="text-center">
                                        <base-button type="primary" class="my-4">Create account</base-button>
                                    </div>
                                </form>
                            </template>
                        </card>
                    </div>
                </div>
            </div> -->
            <div class="container pt-lg-md container-title-content">
                <h3>Tuyển dụng</h3>
            </div>
        </section>
        <section>
            <div class="row" style="margin-top: 30px;">
                <div class="container pt-lg-md navigation-help-list">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="help-content-class tuyendung-content-class">
                                <a name="nap-tien" id="nap-tien"></a>
                                <!-- <NapTien
                                        :items="trogiupjson"
                                /> -->
                                <TuyenDung
                                        :items="tuyendung"
                                    />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TuyenDung from "vue-faq-accordion";
//import HuongDanSuDung from "vue-faq-accordion";
// import axios from 'axios';
// const trogiupjson = "../../../assets/data/tro-giup.json";
import tuyendung from "../assets/data/tin-tuc-tuyen-dung.json";
export default {
    name: "naptien",
        components: {
            TuyenDung
    },
    data() {
        var data = tuyendung.map((item) => {
            return  {
                title: item.MessageTitle,
                value: item.MesssageContent,
            }
        }
        );
        return { tuyendung: data };
    },
    //methods: {
       // parseJson: () =>{
           // return tuyendung = JSON.parse(tuyendung);
        //}
    //}, 
     mounted () {
    //   console.log(process.env);
    //     axios.get('api/api/info/tuyen-dung')
    //   .then(response => {
    //       this.tuyendung = response;
    //   })
  },
    beforeMount(){
        console.log(tuyendung);
    }
};
</script>
<style scoped>
.navigation-help-list{
    padding: 0;
}
</style>